class AeroTermsOfSale {
  constructor() {
    var cart = document.querySelector('#cart');
    if (!cart) return;

    this.checkoutButton = cart.querySelector('[data-aero-checkout]');
    this.dynamicCheckoutButtons = cart.querySelector('[data-aero-dynamic-checkout]');
    this.termsCheckbox = cart.querySelector('[data-aero-terms-checkbox]');
    this.termsTooltip = cart.querySelector('[data-aero-terms-tooltip]');
    this.termsModal = cart.querySelector('[data-aero-terms-modal]');
    this.termsModalOkButton = cart.querySelector('[data-aero-terms-modal-ok]');
    this.cartForm = cart;

    if (this.checkoutButton && this.termsCheckbox) {
      this.init();
    }
  }

  init() {
    this.disableCheckoutButtons();

    this.termsCheckbox.addEventListener('change', () => this.handleCheckboxChange());
    this.checkoutButton.addEventListener('click', (e) => this.handleCheckoutClick(e));

    if (this.cartForm) {
      this.cartForm.addEventListener('submit', (e) => {
        if (!this.termsCheckbox.checked && e.submitter && e.submitter.name === 'checkout') {
          e.preventDefault();
          this.showModal();
        }
      });
    }

    if (this.dynamicCheckoutButtons) {
      this.dynamicCheckoutButtons.addEventListener('click', (e) => {
        if (!this.termsCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          this.showModal();
        }
      }, true);

      this.dynamicCheckoutButtons.addEventListener('mouseenter', () => {
        if (!this.termsCheckbox.checked) {
          this.showTooltip();
        }
      });

      this.dynamicCheckoutButtons.addEventListener('mouseleave', () => {
        this.hideTooltip();
      });

      this.setupMutationObserver();
    }

    this.checkoutButton.addEventListener('mouseenter', () => {
      if (!this.termsCheckbox.checked) {
        this.showTooltip();
      }
    });
    this.checkoutButton.addEventListener('mouseleave', () => this.hideTooltip());

    if (this.termsModalOkButton) {
      this.termsModalOkButton.addEventListener('click', () => this.hideModal());
    }
  }

  setupMutationObserver() {
    var observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length && !this.termsCheckbox.checked) {
          this.disableCheckoutButtons();
        }
      });
    });

    observer.observe(this.dynamicCheckoutButtons, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  handleCheckboxChange() {
    if (this.termsCheckbox.checked) {
      this.enableCheckoutButtons();
      this.hideTooltip();
    } else {
      this.disableCheckoutButtons();
    }
  }

  handleCheckoutClick(e) {
    if (!this.termsCheckbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      this.showModal();
    }
  }

  showTooltip() {
    if (!this.termsCheckbox.checked && this.termsTooltip) {
      this.termsTooltip.style.display = 'block';
    }
  }

  hideTooltip() {
    if (this.termsTooltip) {
      this.termsTooltip.style.display = 'none';
    }
  }

  showModal() {
    if (this.termsModal) {
      this.termsModal.style.display = 'flex';
    }
  }

  hideModal() {
    if (this.termsModal) {
      this.termsModal.style.display = 'none';
    }
  }

  disableCheckoutButtons() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.setAttribute('aria-disabled', 'true');
    }
    if (this.dynamicCheckoutButtons) {
      this.dynamicCheckoutButtons.style.pointerEvents = 'none';
      this.dynamicCheckoutButtons.style.opacity = '0.5';
    }
  }

  enableCheckoutButtons() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = false;
      this.checkoutButton.removeAttribute('aria-disabled');
    }
    if (this.dynamicCheckoutButtons) {
      this.dynamicCheckoutButtons.style.pointerEvents = 'auto';
      this.dynamicCheckoutButtons.style.opacity = '1';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AeroTermsOfSale();
});
